import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Body.css';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import Avatar from '@material-ui/core/Avatar';
import { fetchAllStations } from '../redux/actions/userActions';
import { setStyle } from '../store/index';
import Started from './started';

const accessToken =
  'pk.eyJ1IjoiZ29uemE0NjIiLCJhIjoiY2ppZmRieXk2MGxodDNxb2N2ZzVzbWFvZCJ9.1htrThMOpVkVcrWlHg2Bbg';

// const styleName = "mapbox/light-v9";
const lon = -87.90138864311724;
const lat = 43.07689297210547;
const zoomScale = 12;

class Map extends Component {
  state = {
    currentTruckNum: 0,
    locations: [],
    latitude: 42.9628803,
    longitude: -87.9202306,
    name: '',
    curLt: 0.0,
    curLn: 0.0,
    map: {},
  };

  componentDidMount() {
    mapboxgl.accessToken = accessToken;

    //this.props.setUserLocation(add);
    var map = new mapboxgl.Map({
      container: 'map', // html element id in render
      style: `mapbox://styles/gonza462/ckeejgmny08mv19mi9zpclg9v`,
      center: [lon, lat], // note lon comes before lat - geoJSON convention
      zoom: [zoomScale],
    });
    this.setState({
      map: map,
    });

    map.flyTo({
      center: [-87.9202306, 42.9628803],
      speed: 1.5,
      zoom: 17,
      pitch: 45,
      bearing: 27,
    });

    const { setInitialStations } = this.props;

    map.loadImage('/bluemark.png', function(error, image) {
      if (error) throw error;
      map.addImage('truck', image);
    });
    map.on('load', async () => {
      await setInitialStations().then(() => {
        const { chargingStations } = this.props;
        const { userLocation } = this.props;

        map.addSource('point-truck', {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: chargingStations.map((truck) => {
              return {
                type: 'Feature',
                geometry: {
                  type: 'Point',
                  coordinates: [truck.longitude, truck.latitude],
                },
                properties: {
                  name: truck.name,
                  phone: truck.phone,
                  address: truck.address,
                },
              };
            }),
          },
        });

        map.addLayer({
          id: 'allStations',
          type: 'symbol',
          source: 'point-truck',
          layout: {
            'icon-image': 'truck',
            'icon-size': 0.4,
            'icon-allow-overlap': true,
            'text-allow-overlap': true,
          },
        });
      });
    });

    map.on('click', (e) => {
      map.flyTo(e.lngLat);
      var features = map.queryRenderedFeatures(e.point, {
        layers: ['allStations'],
      });

      if (features.length) {
        var clickedPoint = features[0];

        var ln = clickedPoint.geometry.coordinates[0];
        var lg = clickedPoint.geometry.coordinates[1];

        map.flyTo({
          center: [ln, lg],
          speed: 1.7,
          zoom: 17,
          pitch: 45,
          bearing: 27,
        });

        var name = clickedPoint.properties.name;

        if (name === 'El Tapatio') {
          name = 'Tapatio';
        } else {
        }
        var phone = clickedPoint.properties.phone;
        var address = clickedPoint.properties.address;

        const { userLocation } = this.props;

        new mapboxgl.Popup({ closeOnClick: true })
          .setLngLat([ln, lg])
          .setHTML(
            '<div id="popup-body">' +
              '<img src="tacodrink.png" alt="avar" style="height:36px; margin-bottom:-18px">' +
              '<h3 style="text-align:center; margin-top:-25px;font-weight:bold;">' +
              name +
              '<img src="verified.jpg" style="height:1rem; margin-bottom:-4px">' +
              '</h3>' +
              '</div>' +
              '<h4 style="font-weight:bold;color:#5ebb5e;">' +
              'Open Now' +
              '</h4>' +
              '<div style="margin-top:-18px;">' +
              '<img src="phone.png" alt="some" style="height:0.75rem">' +
              '<a style="text-decoration:none" href=tel:1-' +
              phone +
              '>' +
              '<h4 style="margin-top:-22px; margin-left:20px;font-weight:bold;color: #1e97ff;">' +
              phone +
              '</h4>' +
              '</a>' +
              '<img src="locicon.png" style="height:2.0rem; margin-top:-20px;margin-left:-10px;">' +
              '<h4 style="font-weight:bold; margin-top:-33px; margin-left:20px">' +
              address +
              '</h4>' +
              '</div>' +
              '<div style="margin-top:-14px">' +
              '<img src="stars.jpg" style= "height:1rem;">' +
              '</div>' +
              '<div style="margin-top:-20px">' +
              '<a id = "mapholder" href= http://maps.google.com/maps?saddr=' +
              userLocation.latitude +
              ',' +
              userLocation.longitude +
              '&daddr=' +
              lg +
              ',' +
              ln +
              '>' +
              '<button id="myBtn" style="background-color:#e5e5e5;border-radius:8px;font-weight:bold; color:black; border:1px; margin-top:0px;width:240px;padding:4px; margin-right:5px;">' +
              'Directions' +
              '</button>' +
              '</a>' +
              '<a href=' +
              name +
              '>' +
              '<button style="background-color:#00b2ffd1; color:white;font-weight:bold; border:1px; margin-top:25px;width:110px;padding:4px; border-radius:8px;">' +
              'Menu' +
              '</button>' +
              '</a>' +
              '</div' +
              '</div>'
          )
          .addTo(map);
      }
    });
  }

  flyToStore(currentFeature) {
    var ln = currentFeature.geometry.coordinates[0];
    var lg = currentFeature.geometry.coordinates[1];

    this.map.flyTo({
      center: [ln, lg],
      speed: 0.8,
      zoom: 17,
      pitch: 45,
      bearing: 27,
    });
  }

  render() {
    return (
      <div>
        <a href="/login">
          <div className="userIcon">
            <Avatar
              style={{
                height: '6vh',
                width: '6vh',
                backgroundColor: '#00b2ffd1',
              }}
            >
              <img
                alt=""
                style={{ height: '6vh' }}
                href="/login"
                src="smallup.png"
              />
            </Avatar>
            <div>
              <Started
                isMobile={true}
                handleOpen={true}
                setHandleOpen={false}
              />
            </div>
          </div>
        </a>
        <div>
          <div id="map"></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    style: state.style,
    chargingStations: state.user.chargingStations,
    userLocation: state.user.userLocation,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setStyle: (style) => dispatch(setStyle(style)),
    setInitialStations: () => dispatch(fetchAllStations()),
    setUserLocation: (location) => {
      dispatch({ type: 'SET_USER_LOCATION', location: location });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Map);
